import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-test-start',
    template: '',
})
export class TestStartComponent extends BaseUI implements OnInit {
    @Output()
    public next: EventEmitter<boolean> = new EventEmitter();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnInit() {
        this.next.emit(true);
    }
}
